<input
	type="text"
	[placeholder]="placeholder"
	#valueInput
	(keyup)="search(valueInput.value)"
	[style.width]="width"
	class="form-control form-control-sm"
	[value]="value"
/>
